import { render, staticRenderFns } from "./MaxPerfomance.vue?vue&type=template&id=113a61df&scoped=true&"
import script from "./MaxPerfomance.vue?vue&type=script&lang=js&"
export * from "./MaxPerfomance.vue?vue&type=script&lang=js&"
import style0 from "./MaxPerfomance.vue?vue&type=style&index=0&id=113a61df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113a61df",
  null
  
)

export default component.exports